import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";

import { Box } from "@mui/material";

import useLayoutData from "@/hooks/useLayoutData";

import AppHeader from "../AppBar";
import AppFooter from "../AppFooter";

export const Layout = () => {
  const withFooter = useMemo(() => true, []);
  const { toolbarHeight, footerHeight } = useLayoutData();

  return (
    <div>
      <AppHeader />
      <Helmet>
        <html lang="en" />
        <title>AwardTool | Discover Amazing Award Flight Availability with Ease </title>
        <meta
          name="description"
          content="Discover the best award flight availability to maximize your points and miles with AwardTool.com. Our powerful search engine helps you find top deals across airlines, compare availability, and book your dream trip with ease. Start saving thousands and hours today and unlock incredible travel rewards with expert tips and insights!"
        />
      </Helmet>
      <Box
        sx={{
          minHeight: `calc(100vh - ${toolbarHeight + (withFooter ? footerHeight : 0)}px)`,
        }}
      >
        <Outlet />
      </Box>
      {withFooter ? <AppFooter /> : null}
    </div>
  );
};
